import React from 'react'
import { CustomTooltip } from '../'
import { IconButtonWrapper } from './style'

const MuiIconButton = ({
  children,
  tooltip,
  vAlign,
  align,
  ...restProps
}) => {
  // restProps holds all other props except tooltip, vAlign, children

  return (
    <>
      {tooltip ? (
        <CustomTooltip title={tooltip} vAlign={vAlign || null} align={align || null}>
          <IconButtonWrapper {...restProps}>
            {children}
          </IconButtonWrapper>
        </CustomTooltip>
      ) : (
        <IconButtonWrapper {...restProps}>
          {children}
        </IconButtonWrapper>
      )}
    </>
  )
}

export default MuiIconButton

